import { injectable } from "inversify";
import { IUserData } from "@dp-instant/interfaces";

type Dict = Record<string, any>;

const STORAGE_KEY = "sio_cookie_tg";

@injectable()
export class UserDataTelegram implements IUserData {
    async get(k?: string | string[]): Promise<Dict> {
        const allData = this._load();
        if (!k) return allData;
        if (typeof k === "string") return { [k]: allData[k] };
        return k.reduce((acc: Dict, key: string) => ({ ...acc, [key]: allData[key] }), {});
    }

    async save(key: string, data: any, _delay?: number): Promise<void> {
        const allData = this._load();
        allData[key] = data;
        this._persist(allData);
    }

    async erase(key: string): Promise<boolean> {
        const allData = this._load();
        delete allData[key];
        this._persist(allData);
        return true;
    }

    private _load(): Dict {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            return raw ? JSON.parse(raw) : {};
        } catch {
            return {};
        }
    }

    private _persist(data: Dict): void {
        try {
            localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        } catch {}
    }
}
